/**
 *  @class
 *  @function ToggleBoxes
 */
if (!customElements.get('toggle-box')) {
  class ToggleBox extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector('.toggle-box--button');

      this.button.addEventListener('click', () => {
        this.toggleAttribute('open');
      });

      if(window.innerWidth > 768){
        this.addEventListener('mouseenter', () => {
          this.setAttribute('open','');
        });
        this.addEventListener('mouseleave', () => {
          this.removeAttribute('open');
        });
      }
    }
  }
  customElements.define('toggle-box', ToggleBox);
}